export default (state) => {
  if (!state.subscriptions || !state.subscriptions.current) {
    return undefined;
  }

  const { family } = state.subscriptions.current;

  return family;
};
